var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// db/export-job.ts
import { Arg, Entity, Query } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { exportCSVBufferFromMongo, exportCSVFileFromMongo, exportStringAsFile } from "../server/export-internals.js";
import { ConvertConfig } from "./convert-config.js";
var ExportJob = class extends AdornisEntity {
  static exportCSVStringFromMongo(convertConfig) {
    return async () => {
      const buffer = await exportCSVBufferFromMongo(convertConfig, {});
      return buffer.toString();
    };
  }
  static exportCSVFileFromMongo(convertConfig, filename, encoding = "utf8") {
    return async () => exportCSVFileFromMongo(
      convertConfig,
      { _class: { $in: baseqlMetaData.entities.validSubclasses(convertConfig.className) } },
      filename,
      encoding
    );
  }
  static exportStringAsFile(content, filename, encoding = "utf8") {
    return async () => exportStringAsFile(content, filename, encoding);
  }
};
ExportJob._class = "ExportJob";
__decorateClass([
  Query((type) => String),
  __decorateParam(0, Arg("convertConfig", (type) => ConvertConfig))
], ExportJob, "exportCSVStringFromMongo", 1);
__decorateClass([
  Query((type) => String),
  __decorateParam(0, Arg("convertConfig", (type) => ConvertConfig)),
  __decorateParam(1, Arg("filename", (type) => String)),
  __decorateParam(2, Arg("encoding", (type) => String))
], ExportJob, "exportCSVFileFromMongo", 1);
__decorateClass([
  Query((type) => String),
  __decorateParam(0, Arg("content", (type) => String)),
  __decorateParam(1, Arg("filename", (type) => String)),
  __decorateParam(2, Arg("encoding", (type) => String))
], ExportJob, "exportStringAsFile", 1);
ExportJob = __decorateClass([
  Entity()
], ExportJob);
export {
  ExportJob
};
